// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"innerContainer__35OE0","container":"container__2TDIf","headerText":"headerText__R7VjP","content":"content__2hFGv"};